module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/JM-0d7100da68b6d1f3ae928cdbafea3f32.png";